import Backbone from 'backbone';
import moment from 'moment';

export default Backbone.Model.extend({
  parse(response) {
    response.startTimestamp = moment(response.startTimestamp);
    response.endTimestamp = moment(response.endTimestamp);
    const results = response.results;
    for (let ii = 0, nn = results.length; ii < nn; ii++) {
      const result = results[ii];
      result.startTimestamp = moment(result.startTimestamp);
    }
    return response;
  },
});
